import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  text-align: left;\n  margin: 10px 0 -5px;\n\n  strong {\n    font-weight: 600;\n  }\n\n  ', '\n'], ['\n  text-align: left;\n  margin: 10px 0 -5px;\n\n  strong {\n    font-weight: 600;\n  }\n\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      color: ', ';\n    '], ['\n      color: ', ';\n    ']);

import styled, { css } from 'styled-components';

export var StyledMessage = styled.p(_templateObject, function (_ref) {
  var messageType = _ref.messageType,
      theme = _ref.theme;
  return messageType === 'ERROR' && css(_templateObject2, theme.dormifyRed);
});